import assessPayrollMinLuxury from "./assessPayrollMinLuxury.ts";
import defaultBudgetLevel from "./defaultBudgetLevel.ts";
import getLevelLastThree from "./getLevelLastThree.ts";
import getLuxuryTaxAmount from "./getLuxuryTaxAmount.ts";
import getMinPayrollAmount from "./getMinPayrollAmount.ts";

export default {
	assessPayrollMinLuxury,
	defaultBudgetLevel,
	getLevelLastThree,
	getLuxuryTaxAmount,
	getMinPayrollAmount,
};
